import {createAction} from "@reduxjs/toolkit";
import {SectionFragmentMutateViewModel} from "./FrameActions";

export interface ChangeAmountOfAreaFragmentActionProps {
  amount: number;
}


export const changeAmountOfAreaFragmentAction = createAction<ChangeAmountOfAreaFragmentActionProps>("ChangeAmountOfAreaFragmentActionProps");


// After full refactor split these cuz they for frames

export interface FrameRedistributeToAreaFragmentsActionProps {
  // Do not allow undefined here, if these should be gotten from state dispatcher should specify this by setting it to null
  sectionFragments: SectionFragmentMutateViewModel[] | null;
  areaFragmentIndexesToRedistribute?: number[] | undefined;
}

export const frameRedistributeToAreaFragmentsAction = createAction<FrameRedistributeToAreaFragmentsActionProps>("FrameRedistributeToAreaFragmentsActionProps");


export interface ChangeAmountOfAreaFragmentFramesActionProps {
  areaFragmentId: string;
  amount: number;
}

export const changeAmountOfAreaFragmentFramesAction = createAction<ChangeAmountOfAreaFragmentFramesActionProps>("ChangeAmountOfAreaFragmentFramesActionProps");

export enum PendingMutationType {
  // This is only here to prevent future cases of hard to debug profound retardation
  // aka using == instead of ===
  undefined = 0,
  dormer = 1,
  areaFragment = 2,
  windowInset = 3,
}

export interface DormerPendingMutation extends PendingMutationInterface {
  amountOfSurfaces: number;
}

export interface PendingMutationInterface {
  id: string;
  type: PendingMutationType;
}
export interface AreaFragmentPendingMutation extends PendingMutationInterface {
  locationX: number | null;
  width: number | null;
  amountOfSurfaces: number | null;
}

export interface WindowInsetFragmentPendingMutation extends PendingMutationInterface {
  copiedFromId?: string | undefined;
  locationX?: number;
  width?: number;
}



interface applySelectedAreaFragmentCombinationDeclarationGroupActionProps {
  areaFragmentCombinationDeclarationGroupId: string;
}

export const applySelectedAreaFragmentCombinationDeclarationGroupAction = createAction<applySelectedAreaFragmentCombinationDeclarationGroupActionProps>('applySelectedAreaFragmentCombinationDeclarationGroupAction');

export const applyMostSuitableAreaFragmentCombinationDeclarationGroupAction = createAction('applyMostSuitableAreaFragmentCombinationDeclarationGroupAction');


interface applyPendingAreaFragmentMutationActionProps {
  pendingMutations: AreaFragmentPendingMutation[];
}

export const applyPendingAreaFragmentMutationAction = createAction<applyPendingAreaFragmentMutationActionProps>('applyPendingAreaFragmentMutationAction');



interface applyPendingWindowInsetFragmentMutationActionProps {
  pendingMutations: WindowInsetFragmentPendingMutation[];

}

export const applyPendingWindowInsetFragmentMutationAction = createAction<applyPendingWindowInsetFragmentMutationActionProps>('applyPendingWindowInsetFragmentMutationAction');
